export const PRECIPITATION_LEVELS_IN_ORDER_OF_SEVERITY = [
    "dry",
    "mist",
    "drizzle",
    "rain",
    "heavyrain",
    "hail",
    "snow",
] as const;
